import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Tooltip,
  Radio,
  FormLabel,
  FormControl,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
} from '@mui/material'
import { getLabel } from './utils'

export const CommonRadio = ({
  id,
  label = '',
  value,
  error,
  helperText,
  required = false,
  items = [],
  setValue,
  onChange,
  tooltip,
  labelPlacement = undefined,
  row = false,
  ...muiProps
}) => {
  const selectedValue = value ?? ''

  const handleChange = newValue => {
    if (setValue) setValue(newValue)
    if (onChange) onChange(newValue)
  }

  const normalizedItems = useMemo(() => {
    return Array.isArray(items)
      ? items.map((opt, index) => {
          if (typeof opt === 'object' && opt !== null)
            return { key: index, value: String(opt.id), label: opt.label }
          return { key: index, value: String(opt), label: String(opt) }
        })
      : []
  }, [items])

  return (
    <Box data-testid={id}>
      <FormControl error={!!error} {...muiProps}>
        <FormLabel>{getLabel(label, required)}</FormLabel>
        <RadioGroup
          id={id}
          row={row}
          value={selectedValue}
          onChange={e => handleChange(e.target.value)}
        >
          {normalizedItems.map(item => (
            <Tooltip key={item.key} title={tooltip || ''} placement='top' arrow>
              <FormControlLabel
                value={item.value}
                control={<Radio disabled={muiProps.disabled} />}
                label={item.label}
                labelPlacement={labelPlacement}
                sx={{ marginRight: '0px' }}
              />
            </Tooltip>
          ))}
        </RadioGroup>

        {(error || helperText) && (
          <FormHelperText>{error || helperText}</FormHelperText>
        )}
      </FormControl>
    </Box>
  )
}

CommonRadio.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  helperText: PropTypes.node,
  required: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        label: PropTypes.node,
      }),
    ])
  ),
  setValue: PropTypes.func,
  onChange: PropTypes.func,
  tooltip: PropTypes.string,
  labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']),
  row: PropTypes.bool,
}
